"use client";

import { Download, Package, Settings } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/components/settings/SettingsProvider";

const steps = [
  {
    icon: Settings,
    title: "설정 열기",
    description: "화면의 톱니바퀴 버튼을 눌러 설정을 열어요.",
  },
  {
    icon: Package,
    title: "구매 목록 선택",
    description: "설정에서 구매한 상품과 이전 구매 내역을 확인해요.",
  },
  {
    icon: Download,
    title: "PDF 다운로드",
    description:
      "상품의 다운로드 버튼을 누르세요. 버전별 파일도 다시 받을 수 있어요.",
  },
];

export default function PdfDownloadGuideModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { openSettings } = useSettings();
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>PDF 다운로드 방법</DialogTitle>
          <DialogDescription>
            구매한 PDF는 설정에서 언제든 다시 다운로드할 수 있어요.
          </DialogDescription>
        </DialogHeader>
        <ol className="space-y-5 py-3">
          {steps.map(({ icon: Icon, title, description }, index) => (
            <li key={title} className="flex gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-muted">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold">
                  {index + 1}. {title}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                  {description}
                </p>
              </div>
            </li>
          ))}
        </ol>
        <Button
          onClick={() => {
            onClose();
            openSettings("purchases");
          }}
        >
          구매 목록 열기
        </Button>
      </DialogContent>
    </Dialog>
  );
}
